"use strict";
/** Lightweight in-memory TTL cache for API responses. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCached = getCached;
exports.setCache = setCache;
exports.invalidateCache = invalidateCache;
exports.clearCache = clearCache;
const TTL_MS = 60000; // 60 seconds — matches WP REST cache headers
const store = new Map();
function getCached(key) {
    const entry = store.get(key);
    if (!entry)
        return null;
    if (Date.now() - entry.ts > TTL_MS) {
        store.delete(key);
        return null;
    }
    return entry.data;
}
function setCache(key, data) {
    store.set(key, { data, ts: Date.now() });
}
function invalidateCache(key) {
    store.delete(key);
}
function clearCache() {
    store.clear();
}
//# sourceMappingURL=cache.js.map